import { render, staticRenderFns } from "./editDictionary.vue?vue&type=template&id=310b474e"
import script from "./editDictionary.vue?vue&type=script&lang=js"
export * from "./editDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310b474e')) {
      api.createRecord('310b474e', component.options)
    } else {
      api.reload('310b474e', component.options)
    }
    module.hot.accept("./editDictionary.vue?vue&type=template&id=310b474e", function () {
      api.rerender('310b474e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dictionary/editDictionary.vue"
export default component.exports